<template>
  <font-awesome-icon
    icon="birthday-cake"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons'

library.add(faBirthdayCake)

export default {
  name: 'CoozzyBirthdayIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
